import { render, staticRenderFns } from "./Landingpage.vue?vue&type=template&id=404078e6&scoped=true&"
import script from "./Landingpage.vue?vue&type=script&lang=js&"
export * from "./Landingpage.vue?vue&type=script&lang=js&"
import style0 from "./Landingpage.vue?vue&type=style&index=0&id=404078e6&prod&lang=css&"
import style1 from "./Landingpage.vue?vue&type=style&index=1&id=404078e6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "404078e6",
  null
  
)

export default component.exports